<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            :isShowButton="false"
            @removeService="removeService"
        >
            <template #content>
                <h4 class="mb-2.5 md:mb-4">
                    授權方式：{{ applyWay.name }}
                </h4>

                <ResultList class="md:hidden break-all">
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3 flex-shrink-0">
                            授權人
                        </p>
                        <span class="text-gray-900">{{ data.name }}</span>
                    </li>
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3 flex-shrink-0">
                            身分證字號
                        </p>
                        <span class="text-gray-900">{{ data.id }}</span>
                    </li>
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3  flex-shrink-0">
                            授權扣款銀行
                        </p>
                        <span class="text-gray-900">{{ `${data.shortBankCode}  ${data.bankName}` }}</span>
                    </li>
                    <li class="flex  items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3 flex-shrink-0">
                            授權銀行帳號
                        </p>
                        <span class="text-gray-900">{{ data.bankAccount }}</span>
                    </li>
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3 flex-shrink-0">
                            授權人行動電話
                        </p>
                        <span class="text-gray-900">{{ data.mobile }}</span>
                    </li>
                </ResultList>

                <TableBase
                    class="hidden md:block"
                    :isDashed="true"
                    :cursorPointer="false"
                >
                    <template #thead>
                        <tr class="text-sm lg:text-base">
                            <th class="w-[28%]">
                                授權人/身分證字號
                            </th>
                            <th>
                                授權扣款銀行
                            </th>
                            <th>
                                授權銀行帳號
                            </th>
                            <th>
                                授權人行動電話
                            </th>
                        </tr>
                    </template>
                    <template #tbody>
                        <tr class="text-base xs:text-lg md:text-base lg:text-lg text-gray-900">
                            <td class="break-all">
                                <p>{{ data.name }}</p>
                                <p>{{ data.id }}</p>
                            </td>
                            <td>
                                <p>{{ data.shortBankCode }}</p>
                                <p>{{ data.bankName }}</p>
                            </td>
                            <td>
                                {{ data.bankAccount }}
                            </td>
                            <td>
                                {{ data.mobile }}
                            </td>
                        </tr>
                    </template>
                </TableBase>

                <div class="text-right my-4">
                    <button
                        class="btn-text text-primary border-b border-primary text-[1rem] xs:text-[1.125rem]"
                        @click="goEditAccount"
                    >
                        返回修改授權資料
                    </button>
                </div>
                <h4 class="mb-2.5 md:mb-4">
                    保單明細
                </h4>
                <TableBase
                    :isDashed="true"
                    :cursorPointer="false"
                >
                    <template #thead>
                        <tr class="text-sm lg:text-base">
                            <th>
                                保單號碼
                            </th>
                            <th class="hidden md:table-cell w-[20%]">
                                被保險人
                            </th>
                            <th class="break-all">
                                變更前繳費方式
                            </th>
                            <th class="hidden md:table-cell">
                                幣別
                            </th>
                            <th v-if="data.staff">
                                集團員工優惠
                            </th>
                        </tr>
                    </template>
                    <template #tbody>
                        <tr class="text-base xs:text-lg md:text-base lg:text-lg text-gray-900">
                            <td class="break-all">
                                {{ data.fullPolicyNo }}
                            </td>
                            <td class="hidden md:table-cell break-all">
                                {{ data.insName }}
                            </td>
                            <td class="break-all">
                                {{ data.payKindText }}
                            </td>
                            <td class="hidden md:table-cell">
                                {{ data.currencyText }}
                            </td>
                            <td v-if="data.staff">
                                {{ data.applyStaffDiscount?'申請':'不申請' }}
                            </td>
                        </tr>
                    </template>
                </TableBase>

                <div class="text-right mt-4">
                    <button
                        class="btn-text text-primary border-b border-primary text-[1rem] xs:text-[1.125rem]"
                        @click="goEditPolicy"
                    >
                        返回修改保單資訊
                    </button>
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ResultList from '@/components/template/ResultList.vue';
import TableBase from '@/components/table/TableBase.vue';
import routeName from '@/router/constant.js';
import codeList from '@/json/codeList.js';

export default {
    name: 'TransferData',
    components: {
        CollapseConfirmData,
        ResultList,
        TableBase
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref(codeList.ACH);
        const store = useStore();
        const applyWay = computed(() => store.state.services.changeItemsResult[`${code.value}applyWay`] || {});
        const router = useRouter();
        const removeService = () => {
            emit('removeService', code.value);
        };
        const goEditAccount = () => {
            router.push({ name: routeName.AUTH_ACCOUNT });
        };
        const goEditPolicy = () => {
            router.push({ name: routeName.AUTH_POLICY });
        };
        return {
            code,
            data,
            applyWay,
            removeService,
            goEditPolicy,
            goEditAccount
        };
    },
};
</script>
